<div class="modal-header">
    <div class="row col-12">        
        <div class="modal-title col-10">
            <h3>Kopier databaseskabelon</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true" ><i class="fa-solid fa-x"></i></span>
                </button>    
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row">   
            <form action="">
                <div class="row mb-3">
                    <div class="form-floating col-lg-12 col-12 mb-lg-0 mb-3">
                        <div class="input-group">

                        <label class="input-group-text">Vælg kilde:</label>
                        <select class="form-select" [disabled]="isCopyingTemplate" 
                            [(ngModel)]="selectedGuid" [ngModelOptions]="{standalone: true}">
                            @for (option of dbTables; track $index)
                            {
                                <option 
                                    [value]="option.id">
                                    {{ option.displayName}} ({{ option.tableName }})
                                </option>
                            }
                        </select>
                     </div>
                    </div>
                </div>
            </form>
    </div>
    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" (click)="copyDbTable()" [disabled]="disabled()" >
            @if(isCopyingTemplate)
            {
                <div class="spinner-border spinner-border-sm me-2" role="status">
                    <span class="visually-hidden">Kopier</span>
                </div>
            }                    
            Kopierer skabelon</button> 
    </div>
</div>